/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateDeliveryRequest } from '../models/CreateDeliveryRequest';
import type { CreateResponse } from '../models/CreateResponse';
import type { DeliveryResponse } from '../models/DeliveryResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class DeliveryApi {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Create delivery
   * @param requestBody Create delivery body schema
   * @returns CreateResponse Success create response
   * @throws ApiError
   */
  public createDelivery(
    requestBody?: CreateDeliveryRequest,
  ): CancelablePromise<CreateResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/delivery/',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        401: `Wrong credentials`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Get delivery by id
   * @param id
   * @returns DeliveryResponse Get delivery response
   * @throws ApiError
   */
  public getDeliveryById(
    id: string,
  ): CancelablePromise<DeliveryResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/delivery/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

}
